import OtpVerification from "./OtpVerification";
import { useState } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import StartRegistration from "./StartRegistration";
import SetupPrimaryProperty from "./SetupPrimaryProperty";
import SetupPassword from "./SetupPassword";
import SetupPrimaryAccount from "./SetupPrimaryAccount";
import SuccessfullSignup from "./SuccessfullSignup";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { inviteServices } from "../../APIServices/UserData/inviteServices";

const Signup = ({ setEmail, email, roleType, setRoleType }) => {
  const [nextStep, setNextStep] = useState("startRegistration");
  const [name, setName] = useState("");
  const [invitationStatus, setInvitationStatus] = useState("");
  const [loader, setLoader] = useState(false);
  const { token } = useParams()

  function getTwoInitials() {
    if (!name) return "";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }
    const first = parts[0][0];
    const last = parts[parts.length - 1][0];
    return (first + last).toUpperCase();
  }

  const getInvitationByToken = async () => {
    let data = await inviteServices.getInvitationByToken(token)
    setEmail(data?.data?.email || "")
    setInvitationStatus(data?.data?.status || "expired")
  }

  useEffect(() => {
    if (token) {
      setRoleType("individual")
      getInvitationByToken();
    }
  }, [token]);

  return (
    <Container fluid className="auth-layout">
      <Row className="full-height">
        <Col md={6} className="auth-side d-none d-md-flex align-items-center">
          <div className="auth-content">
            <h1>Create your account</h1>
          </div>
        </Col>
        <Col md={6} className="flex-center">
          <div className="card-box">
            <h3 className="heading-lg text-center mb-4">
              {nextStep === "otpVerification"
                ? "Verify OTP"
                : nextStep === "setupAccount"
                  ? "Account Information"
                  : nextStep === "setupProperty"
                    ? "Property Information"
                    : nextStep === "setupPassword"
                      ? "Password Setup"
                      : nextStep === "successfully"
                        ? "Success aboard 🎉"
                        : "Sign up"}
            </h3>
            {nextStep != "startRegistration" &&
              <Form.Group className="mb-3">
                <div className="hstack gap-2 mb-3">
                  <h6 className={`bg-primary-subtle p-3 rounded-1 fw-bold m-0`}>
                    {getTwoInitials(name)}
                  </h6>
                  <div>
                    <h6 className="m-0">{name}</h6>
                    <p className="small m-0 text-muted">{email}</p>
                  </div>
                </div>
              </Form.Group>
            }
            {nextStep === "startRegistration" && (
              <StartRegistration
                setNextStep={setNextStep}
                setLoader={setLoader}
                loader={loader}
                setName={setName}
                name={name}
                setEmail={setEmail}
                email={email}
                roleType={roleType}
                setRoleType={setRoleType}
                token={token}
              />
            )}

            {nextStep === "otpVerification" && (
              <OtpVerification
                setNextStep={setNextStep}
                setLoader={setLoader}
                loader={loader}
                setName={setName}
                name={name}
                setEmail={setEmail}
                email={email}
                roleType={roleType}
              />
            )}

            {nextStep === "setupAccount" && (
              <SetupPrimaryAccount
                setNextStep={setNextStep}
                setLoader={setLoader}
                loader={loader}
                setName={setName}
                name={name}
                setEmail={setEmail}
                email={email}
              />
            )}

            {nextStep === "setupProperty" && (
              <SetupPrimaryProperty
                setNextStep={setNextStep}
                setLoader={setLoader}
                loader={loader}
                setName={setName}
                name={name}
                setEmail={setEmail}
                email={email}
              />
            )}

            {nextStep === "setupPassword" && (
              <SetupPassword
                setNextStep={setNextStep}
                setLoader={setLoader}
                loader={loader}
                setName={setName}
                name={name}
                setEmail={setEmail}
                email={email}
              />
            )}

            {nextStep === "successfully" && (
              <SuccessfullSignup
                setNextStep={setNextStep}
                setLoader={setLoader}
                loader={loader}
                setName={setName}
                name={name}
                setEmail={setEmail}
                email={email}
              />
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Signup;
